export const steppers = {
    addLogo: "Add logo",
    confirmation: "Confirmation"
}

export enum ImageStatus {
    None,
    IsNotAnImage,
    ImageChosen,
}

export const AddLogoText = {
    LogRecommendations : "Logo recommendations",
    Rules : "We recommend the logo is within the following:",
    Li1 : "95px height by 250px width",
    Li2 : "Transparent background",
    Li3 : "In .png  .jpg  or .svg  formats",
    Li4 : "72 dpi density to look sharp on mobile",
    DoNotWorryMsg :
        "Don't worry if you're not sure of the dimensions as we'll show you what it looks like before you finish.",
    RequiredImg : "Please upload image",
}